import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  Divider,
  Stack,
  IconButton
} from '@mui/material';
import {
  Facebook as FacebookIcon,
  Twitter as TwitterIcon,
  Instagram as InstagramIcon,
  LinkedIn as LinkedInIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  LocationOn as LocationOnIcon
} from '@mui/icons-material';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      sx={{
        bgcolor: 'primary.dark',
        color: 'white',
        py: 6,
        mt: 'auto'
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* 회사 소개 */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              아태미국변호사협회
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              미국 변호사 시험 준비를 위한 최적의 파트너입니다. 
              체계적인 학습 관리와 효율적인 학습 방법을 제공하여 
              여러분의 성공적인 Bar Exam 합격을 지원합니다.
            </Typography>
            <Stack direction="row" spacing={1}>
              <IconButton color="inherit" size="small">
                <FacebookIcon />
              </IconButton>
              <IconButton color="inherit" size="small">
                <TwitterIcon />
              </IconButton>
              <IconButton color="inherit" size="small">
                <InstagramIcon />
              </IconButton>
              <IconButton color="inherit" size="small">
                <LinkedInIcon />
              </IconButton>
            </Stack>
          </Grid>

          {/* 빠른 링크 */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" gutterBottom>
              빠른 링크
            </Typography>
            <Stack spacing={1}>
              <Link href="/about" color="inherit" underline="hover">
                회사 소개
              </Link>
              <Link href="/terms" color="inherit" underline="hover">
                이용약관
              </Link>
              <Link href="/privacy" color="inherit" underline="hover">
                개인정보처리방침
              </Link>
              <Link href="/faq" color="inherit" underline="hover">
                자주 묻는 질문
              </Link>
            </Stack>
          </Grid>

          {/* 연락처 */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" gutterBottom>
              연락처
            </Typography>
            <Stack spacing={2}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <EmailIcon fontSize="small" />
                <Typography variant="body2">
                  bll-pro@bll-pro.com
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <LocationOnIcon fontSize="small" />
                <Typography variant="body2">
                  서울특별시
                </Typography>
              </Box>
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: 'rgba(255, 255, 255, 0.1)' }} />

        {/* 저작권 */}
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" color="inherit">
            © {currentYear} BLL Pro. All rights reserved.
          </Typography>
          <Typography variant="caption" color="inherit" sx={{ mt: 1, display: 'block' }}>
            아태미국변호사협회는 미국 변호사 시험 준비를 위한 교육 서비스를 제공합니다.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 